<div (chartInit)="chartInit($event)"
     [initOpts]="{width: 600, height:200}" [options]="option"
     echarts
     style="height: 200px;">
</div>